import type { ThemeItem } from '../../../core/domain'

export const TOURIST_ITEMS: ThemeItem[] = [
  {
    name: 'Eiffel Tower, Paris',
    imageUrl: null,
    fact: "Built in 1889 as a temporary exhibit, it became the world's most visited monument with 7M visitors/year."
  },
  {
    name: 'Great Wall of China',
    imageUrl: null,
    fact: 'Stretches over 21,000 km across northern China; built over centuries to protect against invasions.'
  },
  {
    name: 'Machu Picchu, Peru',
    imageUrl: null,
    fact: 'A 15th-century Inca citadel set in the Andes at 2,430 m; one of the New Seven Wonders of the World.'
  },
  {
    name: 'Colosseum, Rome',
    imageUrl: null,
    fact: 'Built in 70–80 AD, it held up to 80,000 spectators for gladiatorial contests and public spectacles.'
  },
  {
    name: 'Taj Mahal, Agra',
    imageUrl: null,
    fact: 'Built by Emperor Shah Jahan in memory of his wife; a UNESCO site and symbol of eternal love in white marble.'
  },
  {
    name: 'Statue of Liberty, New York',
    imageUrl: null,
    fact: 'A gift from France to the USA in 1886; standing 93 m tall, she welcomed millions of immigrants to America.'
  },
  {
    name: 'Times Square, New York',
    imageUrl: null,
    fact: "The 'Crossroads of the World'; its dazzling billboards and New Year's Eve ball drop are watched by billions."
  },
  {
    name: 'Angkor Wat, Cambodia',
    imageUrl: null,
    fact: "The world's largest religious monument, built in the 12th century; it appears on Cambodia's national flag."
  },
  {
    name: 'Sagrada Família, Barcelona',
    imageUrl: null,
    fact: "Gaudí's masterpiece under construction since 1882; a UNESCO site and the most visited monument in Spain."
  },
  {
    name: 'Burj Khalifa, Dubai',
    imageUrl: null,
    fact: 'At 828 m, it is the tallest building on Earth; its observation deck on floor 148 offers views of 95 km.'
  },
  {
    name: 'Sydney Opera House',
    imageUrl: null,
    fact: "Jørn Utzon's 1973 masterpiece of sail-shaped shells; a UNESCO World Heritage Site and Australia's icon."
  },
  {
    name: 'Stonehenge, England',
    imageUrl: null,
    fact: 'A prehistoric ring of standing stones built c. 3000 BC; its astronomical alignment still puzzles researchers.'
  },
  {
    name: 'Louvre Museum, Paris',
    imageUrl: null,
    fact: "The world's most visited museum with 9M+ visitors/year; home to the Mona Lisa and 35,000 works of art."
  },
  {
    name: 'Grand Canyon, Arizona',
    imageUrl: null,
    fact: 'Carved by the Colorado River over 5–6 million years; at 446 km long and 1.8 km deep, it is truly immense.'
  },
  {
    name: 'Niagara Falls',
    imageUrl: null,
    fact: 'The most powerful waterfall in North America; over 168,000 m³ of water flows over its edge every minute.'
  },
  {
    name: 'Acropolis of Athens',
    imageUrl: null,
    fact: 'A 5th-century BC citadel housing the Parthenon; the birthplace of democracy and Western civilisation.'
  },
  {
    name: 'Petra, Jordan',
    imageUrl: null,
    fact: "The 'Rose City' carved into pink sandstone by the Nabataeans c. 300 BC; a New Seven Wonders of the World."
  },
  {
    name: 'Big Ben, London',
    imageUrl: null,
    fact: 'The nickname of the Great Bell in the Elizabeth Tower; its hourly chime has rung over Westminster since 1859.'
  },
  {
    name: 'Tower of London',
    imageUrl: null,
    fact: 'A 1,000-year-old royal fortress; it once held royals prisoner and still guards the Crown Jewels today.'
  },
  {
    name: 'Buckingham Palace',
    imageUrl: null,
    fact: 'The official London residence of the British monarch since 1837; the Changing of the Guard draws millions.'
  },
  {
    name: 'Palace of Versailles',
    imageUrl: null,
    fact: "Louis XIV's opulent royal palace built in 1682; its Hall of Mirrors with 357 mirrors is world-famous."
  },
  {
    name: 'Notre-Dame Cathedral, Paris',
    imageUrl: null,
    fact: 'Gothic masterpiece begun in 1163; survived centuries before the devastating 2019 fire and subsequent rebuild.'
  },
  { name: 'Arc de Triomphe', imageUrl: null },
  { name: 'Champs-Élysées', imageUrl: null },
  { name: 'Vatican Museums', imageUrl: null },
  { name: "St. Peter's Basilica", imageUrl: null },
  { name: 'Sistine Chapel', imageUrl: null },
  { name: 'Trevi Fountain, Rome', imageUrl: null },
  { name: 'Pantheon, Rome', imageUrl: null },
  { name: 'Pompeii', imageUrl: null },
  { name: 'Uffizi Gallery, Florence', imageUrl: null },
  { name: 'Leaning Tower of Pisa', imageUrl: null },
  { name: 'Cinque Terre, Italy', imageUrl: null },
  { name: 'Amalfi Coast', imageUrl: null },
  { name: 'Venice Canals', imageUrl: null },
  { name: "St. Mark's Square, Venice", imageUrl: null },
  { name: 'Rialto Bridge', imageUrl: null },
  { name: 'Lake Como, Italy', imageUrl: null },
  { name: 'Barcelona Gothic Quarter', imageUrl: null },
  { name: 'Park Güell, Barcelona', imageUrl: null },
  { name: 'La Rambla, Barcelona', imageUrl: null },
  { name: 'Alhambra, Granada', imageUrl: null },
  { name: 'Mezquita, Córdoba', imageUrl: null },
  { name: 'Seville Cathedral', imageUrl: null },
  { name: 'Prado Museum, Madrid', imageUrl: null },
  { name: 'Casa Batlló, Barcelona', imageUrl: null },
  { name: 'Montserrat Monastery', imageUrl: null },
  { name: 'Camino de Santiago', imageUrl: null },
  { name: 'Lisbon Alfama District', imageUrl: null },
  { name: 'Tower of Belém, Lisbon', imageUrl: null },
  { name: 'Jerónimos Monastery, Lisbon', imageUrl: null },
  { name: 'Pena Palace, Sintra', imageUrl: null },
  { name: 'Douro Valley, Portugal', imageUrl: null },
  { name: 'Edinburgh Castle', imageUrl: null },
  { name: 'Loch Ness, Scotland', imageUrl: null },
  { name: 'Scottish Highlands', imageUrl: null },
  { name: 'Cliffs of Moher, Ireland', imageUrl: null },
  { name: 'Blarney Castle', imageUrl: null },
  { name: 'Ring of Kerry, Ireland', imageUrl: null },
  { name: 'Dublin City', imageUrl: null },
  { name: 'Neuschwanstein Castle, Germany', imageUrl: null },
  { name: 'Cologne Cathedral', imageUrl: null },
  { name: 'Brandenburg Gate, Berlin', imageUrl: null },
  { name: 'Berlin Wall Memorial', imageUrl: null },
  { name: 'Rhine Valley, Germany', imageUrl: null },
  { name: 'Amsterdam Canals', imageUrl: null },
  { name: 'Van Gogh Museum, Amsterdam', imageUrl: null },
  { name: 'Anne Frank House, Amsterdam', imageUrl: null },
  { name: 'Rijksmuseum, Amsterdam', imageUrl: null },
  { name: 'Keukenhof Gardens, Netherlands', imageUrl: null },
  { name: 'Brussels Grand Place', imageUrl: null },
  { name: 'Bruges Historic Centre', imageUrl: null },
  { name: 'Hallstatt, Austria', imageUrl: null },
  { name: 'Vienna State Opera', imageUrl: null },
  { name: 'Schönbrunn Palace, Vienna', imageUrl: null },
  { name: 'Prague Castle', imageUrl: null },
  { name: 'Charles Bridge, Prague', imageUrl: null },
  { name: 'Old Town Square, Prague', imageUrl: null },
  { name: 'Wawel Castle, Kraków', imageUrl: null },
  { name: 'Buda Castle, Budapest', imageUrl: null },
  { name: 'Thermal Baths, Budapest', imageUrl: null },
  { name: 'Dubrovnik Old City, Croatia', imageUrl: null },
  { name: 'Plitvice Lakes National Park', imageUrl: null },
  { name: 'Hvar Island, Croatia', imageUrl: null },
  { name: 'Santorini, Greece', imageUrl: null },
  { name: 'Mykonos, Greece', imageUrl: null },
  { name: 'Delphi, Greece', imageUrl: null },
  { name: 'Meteora Monasteries, Greece', imageUrl: null },
  { name: 'Rhodes Old Town, Greece', imageUrl: null },
  { name: 'Hagia Sophia, Istanbul', imageUrl: null },
  { name: 'Topkapi Palace, Istanbul', imageUrl: null },
  { name: 'Blue Mosque, Istanbul', imageUrl: null },
  { name: 'Grand Bazaar, Istanbul', imageUrl: null },
  { name: 'Cappadocia, Turkey', imageUrl: null },
  { name: 'Pamukkale, Turkey', imageUrl: null },
  { name: 'Ephesus, Turkey', imageUrl: null },
  { name: 'Moscow Kremlin', imageUrl: null },
  { name: 'Red Square, Moscow', imageUrl: null },
  { name: "St. Basil's Cathedral, Moscow", imageUrl: null },
  { name: 'Hermitage Museum, St. Petersburg', imageUrl: null },
  { name: 'Peterhof Palace, Russia', imageUrl: null },
  { name: 'Forbidden City, Beijing', imageUrl: null },
  { name: 'Summer Palace, Beijing', imageUrl: null },
  { name: 'Temple of Heaven, Beijing', imageUrl: null },
  { name: 'Zhangjiajie National Forest Park', imageUrl: null },
  { name: 'Li River, Guilin', imageUrl: null },
  { name: 'The Bund, Shanghai', imageUrl: null },
  { name: 'Potala Palace, Lhasa', imageUrl: null },
  { name: "Terracotta Army, Xi'an", imageUrl: null },
  { name: 'Huangshan (Yellow Mountain)', imageUrl: null },
  { name: 'Victoria Harbour, Hong Kong', imageUrl: null },
  { name: 'Temples of Kyoto, Japan', imageUrl: null },
  { name: 'Mount Fuji, Japan', imageUrl: null },
  { name: 'Fushimi Inari Shrine, Kyoto', imageUrl: null },
  { name: 'Arashiyama Bamboo Grove', imageUrl: null },
  { name: 'Hiroshima Peace Memorial', imageUrl: null },
  { name: 'Nara Deer Park, Japan', imageUrl: null },
  { name: 'Senso-ji Temple, Tokyo', imageUrl: null },
  { name: 'Shibuya Crossing, Tokyo', imageUrl: null },
  { name: 'Himeji Castle, Japan', imageUrl: null },
  { name: 'Hakone, Japan', imageUrl: null },
  { name: 'Gyeongbokgung Palace, Seoul', imageUrl: null },
  { name: 'Jeju Island, South Korea', imageUrl: null },
  { name: 'DMZ, Korea', imageUrl: null },
  { name: 'Halong Bay, Vietnam', imageUrl: null },
  { name: 'Hoi An Ancient Town, Vietnam', imageUrl: null },
  { name: 'Sapa Terraced Rice Fields, Vietnam', imageUrl: null },
  { name: 'Bangkok Grand Palace', imageUrl: null },
  { name: 'Wat Pho, Bangkok', imageUrl: null },
  { name: 'Chiang Mai Temples, Thailand', imageUrl: null },
  { name: 'Phi Phi Islands, Thailand', imageUrl: null },
  { name: 'Bali, Indonesia', imageUrl: null },
  { name: 'Borobudur Temple, Indonesia', imageUrl: null },
  { name: 'Komodo Island, Indonesia', imageUrl: null },
  { name: 'Raja Ampat, Indonesia', imageUrl: null },
  { name: 'Marina Bay Sands, Singapore', imageUrl: null },
  { name: 'Gardens by the Bay, Singapore', imageUrl: null },
  { name: 'Petronas Twin Towers, KL', imageUrl: null },
  { name: 'Maldives Atolls', imageUrl: null },
  { name: 'Sigiriya Lion Rock, Sri Lanka', imageUrl: null },
  { name: 'Varanasi Ghats, India', imageUrl: null },
  { name: 'Jaipur Pink City, India', imageUrl: null },
  { name: 'Amber Fort, Jaipur', imageUrl: null },
  { name: 'Golden Temple, Amritsar', imageUrl: null },
  { name: 'Ajanta and Ellora Caves, India', imageUrl: null },
  { name: 'Backwaters of Kerala, India', imageUrl: null },
  { name: 'Darjeeling, India', imageUrl: null },
  { name: 'Kathmandu, Nepal', imageUrl: null },
  { name: 'Mount Everest Base Camp', imageUrl: null },
  { name: 'Pokhara, Nepal', imageUrl: null },
  { name: "Tiger's Nest Monastery, Bhutan", imageUrl: null },
  { name: 'Karnak Temple, Luxor', imageUrl: null },
  { name: 'Abu Simbel, Egypt', imageUrl: null },
  { name: 'Pyramids of Giza', imageUrl: null },
  { name: 'Valley of the Kings, Egypt', imageUrl: null },
  { name: 'Luxor Temple, Egypt', imageUrl: null },
  { name: 'Nile River Cruise', imageUrl: null },
  { name: 'Marrakech Medina, Morocco', imageUrl: null },
  { name: 'Sahara Desert, Morocco', imageUrl: null },
  { name: 'Chefchaouen Blue City, Morocco', imageUrl: null },
  { name: 'Fez el Bali, Morocco', imageUrl: null },
  { name: 'Cape Town Table Mountain', imageUrl: null },
  { name: 'Kruger National Park, South Africa', imageUrl: null },
  { name: 'Victoria Falls, Zimbabwe/Zambia', imageUrl: null },
  { name: 'Serengeti National Park, Tanzania', imageUrl: null },
  { name: 'Ngorongoro Crater, Tanzania', imageUrl: null },
  { name: 'Zanzibar Island, Tanzania', imageUrl: null },
  { name: 'Robben Island, Cape Town', imageUrl: null },
  { name: 'Mount Kilimanjaro, Tanzania', imageUrl: null },
  { name: 'Iguazu Falls, Argentina/Brazil', imageUrl: null },
  { name: 'Patagonia, Argentina', imageUrl: null },
  { name: 'Torres del Paine, Chile', imageUrl: null },
  { name: 'Easter Island (Rapa Nui)', imageUrl: null },
  { name: 'Galápagos Islands, Ecuador', imageUrl: null },
  { name: 'Amazon Rainforest, Brazil', imageUrl: null },
  { name: 'Christ the Redeemer, Rio', imageUrl: null },
  { name: 'Copacabana Beach, Rio', imageUrl: null },
  { name: 'Ipanema Beach, Rio', imageUrl: null },
  { name: 'Pantanal Wetlands, Brazil', imageUrl: null },
  { name: 'Ouro Preto, Brazil', imageUrl: null },
  { name: 'Perito Moreno Glacier, Argentina', imageUrl: null },
  { name: 'Buenos Aires Recoleta', imageUrl: null },
  { name: 'Salar de Uyuni, Bolivia', imageUrl: null },
  { name: 'Lake Titicaca, Bolivia/Peru', imageUrl: null },
  { name: 'Cuzco, Peru', imageUrl: null },
  { name: 'Nazca Lines, Peru', imageUrl: null },
  { name: 'Chichen Itza, Mexico', imageUrl: null },
  { name: 'Tulum, Mexico', imageUrl: null },
  { name: 'Teotihuacan Pyramids, Mexico', imageUrl: null },
  { name: 'Cenotes of Yucatan, Mexico', imageUrl: null },
  { name: 'Mexico City Zócalo', imageUrl: null },
  { name: 'Museum of Anthropology, Mexico', imageUrl: null },
  { name: 'Old Havana, Cuba', imageUrl: null },
  { name: 'Varadero Beach, Cuba', imageUrl: null },
  { name: 'Old San Juan Fortresses, Puerto Rico', imageUrl: null },
  { name: 'Yellowstone National Park, USA', imageUrl: null },
  { name: 'Yosemite National Park, USA', imageUrl: null },
  { name: 'Zion National Park, USA', imageUrl: null },
  { name: 'Bryce Canyon National Park, USA', imageUrl: null },
  { name: 'Arches National Park, USA', imageUrl: null },
  { name: 'Rocky Mountain National Park, USA', imageUrl: null },
  { name: 'Crater Lake National Park, USA', imageUrl: null },
  { name: 'Denali National Park, Alaska', imageUrl: null },
  { name: 'Everglades National Park, USA', imageUrl: null },
  { name: 'Walt Disney World, Orlando', imageUrl: null },
  { name: 'Las Vegas Strip, USA', imageUrl: null },
  { name: 'Hollywood, Los Angeles', imageUrl: null },
  { name: 'Golden Gate Bridge, San Francisco', imageUrl: null },
  { name: 'Chicago Millennium Park', imageUrl: null },
  { name: 'Smithsonian Museums, Washington DC', imageUrl: null },
  { name: 'Lincoln Memorial, Washington DC', imageUrl: null },
  { name: 'Empire State Building, New York', imageUrl: null },
  { name: 'Central Park, New York', imageUrl: null },
  { name: 'Brooklyn Bridge, New York', imageUrl: null },
  { name: 'Banff National Park, Canada', imageUrl: null },
  { name: 'Vancouver, Canada', imageUrl: null },
  { name: 'Quebec City, Canada', imageUrl: null },
  { name: 'Northern Lights, Iceland', imageUrl: null },
  { name: 'Blue Lagoon, Iceland', imageUrl: null },
  { name: 'Reykjavik, Iceland', imageUrl: null },
  { name: 'Geysir and Gullfoss, Iceland', imageUrl: null },
  { name: 'Norwegian Fjords', imageUrl: null },
  { name: 'Preikestolen (Pulpit Rock), Norway', imageUrl: null },
  { name: 'Lofoten Islands, Norway', imageUrl: null },
  { name: 'Stockholm Old Town', imageUrl: null },
  { name: 'Copenhagen Nyhavn, Denmark', imageUrl: null },
  { name: 'Tivoli Gardens, Copenhagen', imageUrl: null },
  { name: 'Faroe Islands', imageUrl: null },
  { name: 'Rovaniemi, Finnish Lapland', imageUrl: null },
  { name: 'Finnish Lapland Aurora', imageUrl: null },
  { name: 'Uluru (Ayers Rock), Australia', imageUrl: null },
  { name: 'Great Barrier Reef, Australia', imageUrl: null },
  { name: 'Twelve Apostles, Victoria', imageUrl: null },
  { name: 'Blue Mountains, NSW', imageUrl: null },
  { name: 'Kakadu National Park, Australia', imageUrl: null },
  { name: 'Milford Sound, New Zealand', imageUrl: null },
  { name: 'Fiordland National Park, NZ', imageUrl: null },
  { name: 'Hobbiton, New Zealand', imageUrl: null },
  { name: 'Rotorua Geothermal, NZ', imageUrl: null },
  { name: 'Abel Tasman National Park, NZ', imageUrl: null },
  { name: 'Bora Bora, French Polynesia', imageUrl: null },
  { name: 'Tahiti, French Polynesia', imageUrl: null },
  { name: 'Fiji Islands', imageUrl: null },
  { name: 'Hawaii Volcanoes National Park', imageUrl: null },
  { name: 'Waimea Canyon, Kauai', imageUrl: null },
  { name: 'Na Pali Coast, Hawaii', imageUrl: null },
  { name: 'Pearl Harbor Memorial, Hawaii', imageUrl: null },
  { name: 'Waikiki Beach, Hawaii', imageUrl: null },
  { name: 'Palawan, Philippines', imageUrl: null },
  { name: 'Chocolate Hills, Philippines', imageUrl: null },
  { name: 'Banaue Rice Terraces, Philippines', imageUrl: null },
  { name: 'Ha Long Bay, Vietnam', imageUrl: null },
  { name: 'Phong Nha-Ke Bang Cave, Vietnam', imageUrl: null },
  { name: 'Mỹ Sơn Sanctuary, Vietnam', imageUrl: null },
  { name: 'Luang Prabang, Laos', imageUrl: null },
  { name: 'Vang Vieng, Laos', imageUrl: null },
  { name: 'Plain of Jars, Laos', imageUrl: null },
  { name: 'Bagan Temples, Myanmar', imageUrl: null },
  { name: 'Inle Lake, Myanmar', imageUrl: null },
  { name: 'Shwedagon Pagoda, Myanmar', imageUrl: null },
  { name: 'Sigiriya, Sri Lanka', imageUrl: null },
  { name: 'Kandy Temple of the Tooth', imageUrl: null },
  { name: 'Galle Fort, Sri Lanka', imageUrl: null },
  { name: 'Yala National Park, Sri Lanka', imageUrl: null },
  { name: 'Maldives Water Villas', imageUrl: null },
  { name: 'Seychelles Beaches', imageUrl: null },
  { name: 'Masai Mara, Kenya', imageUrl: null },
  { name: 'Amboseli National Park, Kenya', imageUrl: null },
  { name: 'Diani Beach, Kenya', imageUrl: null },
  { name: 'Okavango Delta, Botswana', imageUrl: null },
  { name: 'Sossusvlei Dunes, Namibia', imageUrl: null },
  { name: 'Fish River Canyon, Namibia', imageUrl: null },
  { name: 'Etosha National Park, Namibia', imageUrl: null },
  { name: 'Chobe National Park, Botswana', imageUrl: null },
  { name: 'Madagascar Rainforest', imageUrl: null },
  { name: 'Avenue of the Baobabs, Madagascar', imageUrl: null },
  { name: 'Tsingy de Bemaraha, Madagascar', imageUrl: null },
  { name: 'Mount Nyiragongo, Congo', imageUrl: null },
  { name: 'Virunga Gorillas, Rwanda', imageUrl: null },
  { name: 'Bwindi Forest, Uganda', imageUrl: null },
  { name: 'Murchison Falls, Uganda', imageUrl: null },
  { name: 'Ethiopian Highlands', imageUrl: null },
  { name: 'Lalibela Rock Churches, Ethiopia', imageUrl: null },
  { name: 'Simien Mountains, Ethiopia', imageUrl: null },
  { name: 'Danakil Depression, Ethiopia', imageUrl: null },
  { name: 'Lamu Archipelago, Kenya', imageUrl: null },
  { name: 'Watamu Marine Park, Kenya', imageUrl: null },
  { name: 'Lake Nakuru, Kenya', imageUrl: null },
  { name: 'Kilwa Kisiwani, Tanzania', imageUrl: null },
  { name: 'Stone Town, Zanzibar', imageUrl: null },
  { name: 'Bazaruto Archipelago, Mozambique', imageUrl: null },
  { name: 'Mozambique Island', imageUrl: null },
  { name: 'Quirimbas Archipelago, Mozambique', imageUrl: null },
  { name: 'Tofo Beach, Mozambique', imageUrl: null },
  { name: 'Livingstone, Zambia', imageUrl: null },
  { name: 'South Luangwa Park, Zambia', imageUrl: null },
  { name: 'Lower Zambezi, Zambia', imageUrl: null },
  { name: 'Hwange National Park, Zimbabwe', imageUrl: null },
  { name: 'Great Zimbabwe Ruins', imageUrl: null },
  { name: 'Matobo Hills, Zimbabwe', imageUrl: null },
  { name: 'Namib Desert, Namibia', imageUrl: null },
  { name: 'Cape Cross Seal Colony, Namibia', imageUrl: null },
  { name: 'Skeleton Coast, Namibia', imageUrl: null },
  { name: 'Mossel Bay, South Africa', imageUrl: null },
  { name: 'Garden Route, South Africa', imageUrl: null },
  { name: 'Kruger to Mozambique Corridor', imageUrl: null },
  { name: 'Sabi Sands, South Africa', imageUrl: null },
  { name: 'Drakensberg Mountains, South Africa', imageUrl: null },
  { name: 'iSimangaliso Wetland Park, SA', imageUrl: null },
  { name: 'Kirstenbosch Gardens, Cape Town', imageUrl: null },
  { name: 'Winelands of Stellenbosch, SA', imageUrl: null },
  { name: 'Hermanus Whale Watching, SA', imageUrl: null },
  { name: 'De Hoop Nature Reserve, SA', imageUrl: null },
  { name: 'Cape Agulhas, South Africa', imageUrl: null },
  { name: 'Namaqualand Wildflowers, SA', imageUrl: null },
  { name: 'Augrabies Falls, South Africa', imageUrl: null },
  { name: 'Kgalagadi Transfrontier Park, SA', imageUrl: null },
  { name: 'Blyde River Canyon, SA', imageUrl: null },
  { name: 'Pilanesberg National Park, SA', imageUrl: null },
  { name: 'Sun City Resort, South Africa', imageUrl: null },
  { name: 'Valley of Desolation, SA', imageUrl: null },
  { name: 'Baviaanskloof, South Africa', imageUrl: null },
  { name: 'Tsitsikamma National Park, SA', imageUrl: null },
  { name: "Jeffrey's Bay, South Africa", imageUrl: null },
  { name: 'Wild Coast, South Africa', imageUrl: null },
  { name: 'Coffee Bay, South Africa', imageUrl: null }
]
